import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { SinglePickerList } from "@/src/components/singlePicker";
import { Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { uid } from "@/src/utils/utils";
import { useState } from "react";

export function DuplicatePatientsPicker({
  patients,
  current,
  onChange,
}: {
  patients: Patient[];
  current: Patient | null | undefined;
  onChange: (newPatient: Patient | null | undefined) => void;
}) {
  const [searchKey, setSearchKey] = useState<string | null>("");
  const [value, setValue] = useState<Patient | null | undefined>(current);

  return (
    <div className="c1 gap10">
      <SinglePickerList
        queryKey={["DuplicatePatientsPicker", uid()]}
        current={value}
        limit={1000}
        nullTitle={"Nouveau patient"}
        disableSearch={true}
        onChange={(newValue) => {
          setValue(newValue);
          onChange(newValue);
        }}
        loadItems={async (limit, offset, searchKey) => {
          return (
            patients
          );
        }}
        getChecboxCardContent={(patient) => {
          return (
            <div className="c1 gap10">
              <div className="bold">{patient.firstName} {patient.lastName}</div>
            </div>
          );
        }}
      ></SinglePickerList>
    </div>
  );
}

export async function openDuplicatePatientsPicker({
  current,
  onSelect,
}: {
  current: Patient | null | undefined;
  onSelect: (newPatient: Patient | null | undefined) => void;
}) {
  let selectedPatient: Patient | null | undefined = current;
  const patients = await apiFetch("patients", "detectPatients", {
    firstName: current?.firstName,
    lastName: current?.lastName,
    birth: current?.birth,
    nin: current?.nin,
  });
  console.log("patients", patients);
  await openDrawer({
    id: "duplicatePatientsPicker",
    title: "Choisir un patient",
    additionalClasses: ["small"],
    content: (
        <DuplicatePatientsPicker
        patients={patients}
        current={current}
        onChange={async (patient) => {
          selectedPatient = patient;
        }}
      ></DuplicatePatientsPicker>
    ),
    confirmOnEnter: true,
    onConfirm: async () => {
      await onSelect(selectedPatient);
      closeDrawer("duplicatePatientsPicker");
    },
  });
}
